@if (!layoutService.isTabletDownView.value) {
  <div class="view-detail-border">
    <div class="text-detail-content">
      <div class="pre-icons">
        <div class="pre-space-color" data-cy="space-color" [style.background-color]="spaceDetail?.color_code"></div>
        <span class="space-name" data-cy="space-name">{{ spaceDetail?.name }}</span>
      </div>
      <div class="class-detail">
        <p>
          <span data-cy="teacher-num">担当先生：{{ spaceDetail?.teachers_count | number }}名</span>
          @if (spaceDetail?.managed_by_user) {
            <span data-cy="managed-user">（担当中）</span>
          }
          <span class="user-count" data-cy="student-num">参加生徒：{{ spaceDetail?.users_count | number }}名</span>
          <a class="spen-util-link" data-cy="participants-list" (click)="showParticipantsList()">一覧を見る</a>
        </p>
        <p data-cy="create-user">作成者：{{ spaceDetail?.create_user_name }}先生</p>
        <p>
          <span class="create-time" data-cy="created-at">作成日時：{{ spaceDetail?.created_at }}</span>
          @if (spaceDetail?.updated_at !== '-') {
            <span data-cy="updated-at">更新日時：{{ spaceDetail?.updated_at }}</span>
          }
        </p>
        @if (spaceDetail?.school_year) {
          <p data-cy="school-year">年度：{{ spaceDetail?.school_year }}年度</p>
        }
        <span class="cross-setting-block">
          @for (item of listCrossSettings; track $index) {
            <label class="cross-setting-{{ item?.value ? '' : 'not-' }}allow" data-cy="cross-setting">
              @if (!item?.value) {
                <i class="fa fa-ban" data-cy="setting-disable"></i>
              }
              {{ item?.name }}
            </label>
          }
        </span>
      </div>
    </div>
    @if (isShowLinkSetting) {
      <div class="link-setting">
        @if (spaceDetail?.can_be_edited) {
          <a class="spen-util-link" data-cy="can-be-edited" routerLink="/spaces/teacher/{{ spaceDetail?.id }}/edit"> 変更・削除 </a>
        }
        <br />
        @if (spaceDetail?.managed_by_user) {
          <a class="spen-util-link" data-cy="can-add-work" [routerLink]="['/works', 'new']" [state]="{ space: spaceDetail }">
            新規課題配信
          </a>
        }
        <br />
        @if (spaceDetail?.managed_by_user) {
          <a
            class="spen-util-link"
            data-cy="can-add-album"
            [routerLink]="['/albums', 'teacher', 'delivery', 'new']"
            [queryParams]="{ space_id: spaceDetail.id }"
          >
            新規アルバム配信
          </a>
        }
        <br />
        @if (spaceDetail?.managed_by_user) {
          @if (spaceDetail?.is_delivered_graduation_message) {
            <p>卒業メッセージ配信済</p>
          } @else {
            <a
              class="spen-util-link"
              data-cy="can-add-graduation-messages"
              [routerLink]="['/graduation-messages', 'teacher', 'new']"
              [state]="{ space: spaceDetail }"
            >
              卒業メッセージ配信
            </a>
          }
        }
      </div>
    }
  </div>
} @else {
  <div class="view-detail-border">
    <span class="text-detail-content">
      <div class="pre-icons">
        <div class="pre-space-color" data-cy="space-color" [style.background-color]="spaceDetail?.color_code"></div>
        <span class="space-name" data-cy="space-name">{{ spaceDetail?.name }}</span>
      </div>
      <div class="class-detail">
        @if (isShowLinkSetting) {
          <div class="block-info pull-right">
            <label class="spen-mod-select" [class.is-selecting]="isShowDropdownActions">
              <button class="spen-mod-btn dropdown-toggle" data-cy="show-menu" (click)="isShowDropdownActions = !isShowDropdownActions">
                <img src="/assets/images/icon-dots.svg" alt="dot-icon" />
              </button>
              <div class="image-select-box">
                <ul class="option-list">
                  @if (spaceDetail?.can_be_edited) {
                    <li>
                      <a routerLink="/spaces/teacher/{{ spaceDetail?.id }}/edit" class="dropdown-item" data-cy="can-be-edited">
                        変更・削除
                      </a>
                    </li>
                  }
                  @if (spaceDetail?.managed_by_user) {
                    <li>
                      <a class="dropdown-item" data-cy="can-add-work" [routerLink]="['/works', 'new']" [state]="{ space: spaceDetail }">
                        新規課題配信
                      </a>
                    </li>
                  }
                  @if (spaceDetail?.managed_by_user) {
                    <li>
                      <a
                        class="dropdown-item"
                        data-cy="can-add-album"
                        [routerLink]="['/albums', 'teacher', 'delivery', 'new']"
                        [queryParams]="{ space_id: spaceDetail.id }"
                        >新規アルバム配信</a
                      >
                    </li>
                  }
                  @if (spaceDetail?.managed_by_user) {
                    <li>
                      @if (spaceDetail?.is_delivered_graduation_message) {
                        <p>卒業メッセージ配信済</p>
                      } @else {
                        <a
                          class="dropdown-item"
                          data-cy="can-add-graduation-messages"
                          [routerLink]="['/graduation-messages', 'teacher', 'new']"
                          [state]="{ space: spaceDetail }"
                          >卒業メッセージ配信</a
                        >
                      }
                    </li>
                  }
                </ul>
              </div>
            </label>
          </div>
        }
        <p>
          <span data-cy="teacher-num">担当先生：{{ spaceDetail?.teachers_count | number }}名</span>
          @if (spaceDetail?.managed_by_user) {
            <span data-cy="managed-user">（担当中）</span>
          }
        </p>
        <p data-cy="student-num">生徒：{{ spaceDetail?.users_count | number }}名</p>
        @if (!showMoreInMobile) {
          <div class="show-more">
            <a class="spen-util-link" data-cy="show-more" (click)="showMoreInMobile = true">
              <span>もっと見る</span>
              <i class="fa fa-chevron-down"></i>
            </a>
          </div>
        } @else {
          <div class="students-list">
            <a class="spen-util-link" data-cy="participants-list" (click)="showParticipantsList()">一覧を見る</a>
          </div>
          <p data-cy="create-user">作成者：{{ spaceDetail?.create_user_name }}先生</p>
          <p data-cy="created-at">作成日時：{{ spaceDetail?.created_at }}</p>
          @if (spaceDetail?.updated_at !== '-') {
            <p data-cy="updated-at">更新日時：{{ spaceDetail?.updated_at }}</p>
          }
          @if (spaceDetail?.school_year) {
            <p data-cy="school-year">年度：{{ spaceDetail?.school_year }}年度</p>
          }
          <span class="cross-setting-block">
            @for (item of listCrossSettings; track $index) {
              <label class="cross-setting-{{ item?.value ? '' : 'not-' }}allow" data-cy="cross-setting">
                @if (!item?.value) {
                  <i class="fa fa-ban" data-cy="setting-disable"></i>
                }
                {{ item?.name }}
              </label>
            }
          </span>
        }
      </div>
    </span>
  </div>
}

@if (isShowParticipants) {
  <app-modal-participants-list (eventCancel)="hideParticipantsList($event)" [spaceId]="spaceDetail.id"> </app-modal-participants-list>
}
